/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './PersonalizedServicesCard.scss';

import { kebabCase, startCase } from 'lodash';
import { object, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as AlaskaGoTuition } from 'assets/alaska-529-go-tuition.svg';
import { ReactComponent as AlaskaEducationPlanningCenter } from 'assets/alaska-529-education-planning-center.svg';
import { ReactComponent as MarylandGoTuition } from 'assets/maryland-529-go-tuition.svg';
import { ReactComponent as NationalGoTuition } from 'assets/national-529-go-tuition.svg';
import { ReactComponent as NationalEducationPlanningCenter } from 'assets/national-529-education-planning-center.svg';
import { ReactComponent as PersonalizedServicesVideo } from 'assets/video-image.svg';
import Optioner from 'components/shared/Optioner/Optioner';
import ExternalLinkModal from 'components/shared/Modal/ExternalLinkModal';
import { contentConverter } from 'services/Content';
import LinkButton from 'components/shared/Buttons/LinkButton';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import { customVideoEnabled } from 'services/FeatureFlags';

const PersonalizedServicesCard = ({
  className = '',
  imageType = '',
  title = '',
  content = '',
  linkUrls = '',
  isEducation,
  isVideo,
  isAlaska529 = false,
  collegeProduct
}) => {
  if (imageType === '') {
    return null;
  }

  const convertedContent = contentConverter.makeHtml(content);
  const convertedTitle = contentConverter.makeHtml(title);
  const EducationLinkButton = ({ text, handleClick }) => {
    return <LinkButton text={text} onClick={handleClick} />;
  };

  const EducationLinkButtonWithPermissions =
    WithUserPermissions(EducationLinkButton);

  return (
    <div className={className}>
      <Optioner val={imageType}>
        {{
          AlaskaEducationPlanningCenter: () => (
            <AlaskaEducationPlanningCenter
              className={`e2e-personalized-service-svg e2e-${kebabCase(
                imageType
              )}-svg`}
            />
          ),
          AlaskaGoTuition: () => (
            <AlaskaGoTuition
              className={`e2e-personalized-service-svg e2e-${kebabCase(
                imageType
              )}-svg`}
            />
          ),
          MarylandGoTuition: () => (
            <MarylandGoTuition
              className={`e2e-personalized-service-svg e2e-${kebabCase(
                imageType
              )}-svg`}
            />
          ),
          NationalGoTuition: () => (
            <NationalGoTuition
              className={`e2e-personalized-service-svg e2e-${kebabCase(
                imageType
              )}-svg`}
            />
          ),
          NationalEducationPlanningCenter: () => (
            <NationalEducationPlanningCenter
              className={`e2e-personalized-service-svg e2e-${kebabCase(
                imageType
              )}-svg`}
            />
          ),
          Video: () => (
            <PersonalizedServicesVideo
              className={`e2e-personalized-service-svg e2e-${kebabCase(
                imageType
              )}-svg`}
            />
          ),
          _: null
        }}
      </Optioner>
      {convertedContent !== '' && (
        <div className="personalized-services-card-content-container">
          <div className="personalized-services-card-title">
            <span dangerouslySetInnerHTML={{ __html: convertedTitle }} />
          </div>
          <div className="personalized-services-card-content">
            <span dangerouslySetInnerHTML={{ __html: convertedContent }} />
          </div>
          <div className="personalized-services-card-link">
            {Object.keys(linkUrls).map((name) => {
              const linkName = startCase(name);
              const linkUrl = linkUrls[name];
              return isEducation ? (
                <ExternalLinkModal key={linkName} isAlaska529={isAlaska529}>
                  {({ openModal }) => (
                    <EducationLinkButtonWithPermissions
                      text={linkName}
                      handleClick={openModal}
                      shouldDisable={true}
                    />
                  )}
                </ExternalLinkModal>
              ) : isVideo ? (
                customVideoEnabled() ? (
                  <Link
                    key={linkName}
                    className="external-link-button"
                    to={{
                      pathname: '/custom-video',
                      search: `?productType=${collegeProduct}`
                    }}>
                    {linkName}
                  </Link>
                ) : (
                  <LinkButton
                    key={linkName}
                    link={linkUrl}
                    className="external-link-button"
                    text={linkName}
                    withPermissions={true}
                    shouldDisable={true}
                  />
                )
              ) : (
                <LinkButton
                  key={linkName}
                  link={linkUrl}
                  className="external-link-button"
                  text={linkName}
                  linkTarget={'_blank'}
                  withPermissions={true}
                  shouldDisable={true}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

PersonalizedServicesCard.propTypes = {
  imageType: string,
  title: string,
  content: string,
  linkUrls: object
};

export default PersonalizedServicesCard;
